import React, { useEffect, useRef } from "react";
import gradient from "../assets/img/gradient.png";
import ShowReel from "../assets/videos/hob-showreel.mp4";

function Video() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      video.muted = true;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");

      const tryPlay = () => {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch((err) => {
            console.warn("Autoplay failed:", err);
          });
        }
      };

      // Try to autoplay immediately
      tryPlay();

      // Fallback for iOS Low Power Mode — real gesture
      const handleUserGesture = () => {
        tryPlay();
        document.removeEventListener("touchstart", handleUserGesture);
        document.removeEventListener("scroll", handleUserGesture);
      };

      document.addEventListener("touchstart", handleUserGesture, {
        once: true,
      });
      document.addEventListener("scroll", handleUserGesture, { once: true });

      return () => {
        document.removeEventListener("touchstart", handleUserGesture);
        document.removeEventListener("scroll", handleUserGesture);
      };
    }
  }, []);

  return (
    <section>
      <div className="video">
        <video
          ref={videoRef}
          src={ShowReel}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          poster="/assets/images/fallback.jpg"
        />
      </div>
      <div className="gradienti-ballin">
        <img src={gradient} alt="Gradient Overlay" />
      </div>
    </section>
  );
}

export default Video;
